import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE =
  "updateSTANDARDORDERPACKINGTableStructure";
export const UPDATE_TABLE_DATA = "updateSTANDARDORDERPACKINGTableData";
export const EXPORT_TABLE_DATA = "exportSTANDARDORDERPACKINGTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSTANDARDORDERPACKINGTableStructure";
export const SET_TABLE_DATA = "setSTANDARDORDERPACKINGTableData";
export const SET_TABLE_FILTER = "setSTANDARDORDERPACKINGTableFilter";
export const SET_TABLE_PAGE = "setSTANDARDORDERPACKINGTablePage";
export const SET_TABLE_PERPAGE = "setSTANDARDORDERPACKINGTablePerPage";
export const SET_TABLE_SORTBY = "setSTANDARDORDERPACKINGTableSortBy";
export const SET_TABLE_SORTORDER = "setSTANDARDORDERPACKINGTableSortOrder";
export const SET_EXPORT_LINK = "setSTANDARDORDERPACKINGExportLink";
export const SET_SUGGESTED_DETAILS = "setSTANDARDORDERPACKINGSuggestedDetails";
export const SET_SCANNED_ITEMS = "setSTANDARDORDERPACKINGScannedItems";
export const SET_TOTE_PACKING_ORDER_INFO =
  "setSTANDARDORDERPACKINGTotePackingOrderInfo";
export const SET_TOTE_PACKING_SUGGESTED_DETAILS =
  "setSTANDARDORDERPACKINGTotePackingSuggestedDetails";
export const SET_TOTE_PACKING_SCANNED_ITEMS =
  "setSTANDARDORDERPACKINGTotePackingScannedItems";
export const SET_TOTE_PACKING_PENDING_ITEMS =
  "setSTANDARDORDERPACKINGTotePackingPendingItems";
export const SET_TOTE_PACKING_PRINTS =
  "setSTANDARDORDERPACKINGTotePackingPrints";
export const SET_PACKED_ITEMS = "setSTANDARDORDERPACKINGPackedItems";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  suggestions: {},
  scanned_items: [],
  tote_packing: {
    order_info: {},
    suggested_details: {},
    scanned_items: [],
    pending_items: [],
    prints: [],
  },
  packed_items: [],
};

const getters = {
  getSTANDARDORDERPACKINGTableProperties(state) {
    return state.table_structure.properties;
  },
  getSTANDARDORDERPACKINGTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSTANDARDORDERPACKINGTableState(state) {
    return state.table_state;
  },

  getSTANDARDORDERPACKINGTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSTANDARDORDERPACKINGTableFilters(state) {
    return state.table_structure.filters;
  },

  getSTANDARDORDERPACKINGTableData(state) {
    return state.table_data.data;
  },
  getSTANDARDORDERPACKINGUploadType(state) {
    return state.table_structure.type;
  },
  getSTANDARDORDERPACKINGExportUrl(state) {
    return state.export_link;
  },
  getSTANDARDORDERPACKINGSuggestedDetails(state) {
    return state.suggestions;
  },
  getSTANDARDORDERPACKINGScannedItems(state) {
    return state.scanned_items;
  },
  getSTANDARDORDERPACKINGUsers(state) {
    return state.table_structure.users;
  },
  getSTANDARDORDERPACKINGTotePackingOrderInfo(state) {
    return state.tote_packing.order_info;
  },
  getSTANDARDORDERPACKINGTotePackingSuggestedDetails(state) {
    return state.tote_packing.suggested_details;
  },
  getSTANDARDORDERPACKINGTotePackingScannedItems(state) {
    return state.tote_packing.scanned_items;
  },
  getSTANDARDORDERPACKINGTotePackingPendingItems(state) {
    return state.tote_packing.pending_items;
  },
  getSTANDARDORDERPACKINGTotePackingPrints(state) {
    return state.tote_packing.prints;
  },
  getSTANDARDORDERPACKINGPackedItems(state) {
    return state.packed_items;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/custom/standard_order_packaging")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    // state.page_loading = true;
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post(
        "/warehouse_management/custom/standard_order_packaging/datatable",
        payload
      )
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          // state.page_loading = false;
          setTimeout(() => {
            window.scrollTo(0, 0);
            context.commit(SET_PAGE_LOADING, false);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/standard_order_packaging/export",
        payload
      )
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_SUGGESTED_DETAILS](state, data) {
    if (data.operation === "spread") {
      state.suggestions = { ...state.suggestions, ...data.info };
    } else {
      state.suggestions = data.info;
    }
  },
  [SET_SCANNED_ITEMS](state, data) {
    if (data.operation === "spread") {
      state.scanned_items = { ...state.scanned_items, ...data.data };
    } else {
      state.scanned_items = data.data;
    }
  },
  [SET_PACKED_ITEMS](state, data) {
    state.packed_items = [...data];
  },
  [SET_TOTE_PACKING_ORDER_INFO](state, data) {
    state.tote_packing.order_info = data;
  },
  [SET_TOTE_PACKING_SUGGESTED_DETAILS](state, data) {
    state.tote_packing.suggested_details = data;
  },
  [SET_TOTE_PACKING_SCANNED_ITEMS](state, data) {
    state.tote_packing.scanned_items = data;
  },
  [SET_TOTE_PACKING_PENDING_ITEMS](state, data) {
    state.tote_packing.pending_items = data;
  },
  [SET_TOTE_PACKING_PRINTS](state, data) {
    state.tote_packing.prints = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
